import Resizer from 'react-image-file-resizer';

const MAX_LOGO_DIMENSION = 124;

export const resizeFile = async (file: File): Promise<File> => {
    const type = file.type.split('/')[1] === 'png' ? 'PNG' : 'JPEG';

    return new Promise(resolve => {
        Resizer.imageFileResizer(
            file,
            MAX_LOGO_DIMENSION,
            MAX_LOGO_DIMENSION,
            type,
            100,
            0,
            uri => {
                resolve(uri as unknown as File);
            },
            'file'
        );
    });
};
export const getThumbnailFromFile = async (file: File): Promise<string> => {
    if (file.type.startsWith('image/')) {
        return new Promise(resolve => {
            const reader = new FileReader();

            reader.onloadend = () => {
                if (typeof reader.result === 'string') {
                    resolve(reader.result);
                }
            };

            reader.readAsDataURL(file);
        });
    }

    return '';
};
